<template>
  <SectionPanel
    :step="1"
    :candidate="candidate"
    description="Sus documentos y requisitos como agente de seguridad. Cuando renueve alguno, súbalo de nuevo aquí."
    @edit="(step) => $emit('edit', step)"
  >
    <InlineSectionEditor
      ref="editor"
      :step="1"
      :candidate="candidate"
      :user-email="userEmail"
      @dirty="(value) => $emit('dirty', value)"
      @saved="(step) => $emit('saved', step)"
      @autosaved="(event) => $emit('autosaved', event)"
      @autosave-blocked="(missing) => $emit('autosave-blocked', missing)"
      @autosave-failed="(message) => $emit('autosave-failed', message)"
    />
  </SectionPanel>
</template>

<script>
import InlineSectionEditor from "./InlineSectionEditor.vue";
import SectionPanel from "./SectionPanel.vue";

// Documentación: its documents, with their expiry badges, uploaded and renewed right here.
export default {
  name: "PortalDocumentsTab",
  components: { InlineSectionEditor, SectionPanel },
  props: {
    candidate: { type: Object, required: true },
    userEmail: { type: String, default: "" },
  },
  methods: {
    // Saves what is waiting before leaving the section (see InlineSectionEditor's flush()).
    flush() {
      return this.$refs.editor ? this.$refs.editor.flush() : Promise.resolve(true);
    },
  },
};
</script>
